import Image from 'next/image';
import { useState } from 'react';
import AnchorCoverTag from '../AnchorCoverTag';
import { ImageBox, ResponsiveImageDiv } from './styled';

export default function BannersGridImage(props) {
  const { element, onBannerClick, parentIndex, banner, sectionHeading } = props;
  const [cardEffect, setCardEffect] = useState('');

  const checkImageExist = (product) => {
    let image =
      product?.mobileWebImage || product?.desktopImage || product?.image;
    return image;
  };
  const getSizesString = (itemCount) => {
    switch (itemCount) {
      case 4:
        return '(max-width: 720px) 50vw, 25vw';
      case 3:
        return '(max-width: 720px) 100vw, 33vw';
      case 2:
        return '50vw';
      default:
        return '100vw';
    }
  };
  const getDesktopImage = (product) => {
    return product?.desktopImage || product?.mobileWebImage || product?.image;
  };
  const getMobileImage = (product) => {
    return product?.mobileWebImage || product?.desktopImage || product?.image;
  };

  const deepLinkUrl = element?.deeplinkValue;

  return (
    <ImageBox
      key={`bannersgrid${element?.image}`}
      gridSize={banner?.items?.length}
    >
      {checkImageExist(element) ? (
        <AnchorCoverTag
          callbackFunction={onBannerClick}
          url={deepLinkUrl}
          cardEffect={cardEffect}
          element={element}
        >
          <ResponsiveImageDiv gridSize={banner?.items?.length}>
            <Image
              src={getMobileImage(element)}
              className={`image carousel-mobile`}
              alt={element?.itemName || element?.heading || sectionHeading}
              onClick={() => {
                setCardEffect('lowOpacity');
                setTimeout(() => {
                  setCardEffect('');
                }, 1000);
              }}
              loading={parentIndex == 0 ? 'eager' : 'lazy'}
              quality={90}
              fill
              sizes={getSizesString(banner?.items?.length)}
            />
            <Image
              src={getDesktopImage(element)}
              className={'image carousel-desktop'}
              alt={element?.itemName}
              onClick={() => {
                setCardEffect('lowOpacity');
              }}
              loading={parentIndex == 0 ? 'eager' : 'lazy'}
              quality={90}
              fill
              sizes={getSizesString(banner?.items?.length)}
            />
          </ResponsiveImageDiv>
        </AnchorCoverTag>
      ) : null}
    </ImageBox>
  );
}
